export default __webpack_public_path__ + "a3ad49c8e5d72a47ab040830354729c7.png";